import {Component, OnInit, ViewChild} from '@angular/core';
import { ApiClientService } from '../../../../services/api-client.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { UrlService } from '../../../../services/url.service';
import { NgForm } from '@angular/forms';
import { ConstantsService } from '../../../../services/constants.service';
import { PropertyService } from '../services/property.service';
import { ResidentService } from '../../../../services/resident.service';


declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'welcome-message-modal',
    templateUrl: './welcome-message-modal.component.html',
    styleUrls: ['./welcome-message-modal.component.scss']
})
export class WelcomeMessageModal implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    welcomeMessage = '';
    placeholders = [
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]'
    ];

    constructor(
        public api: ApiClientService,
        public propertyService: PropertyService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        public residentService: ResidentService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        this.welcomeMessage = this.propertyService.currentWelcomeMessage ? this.propertyService.currentWelcomeMessage.slice() : '';
    }

    hideModal() {
        if(this.residentService.dontShowWelcomeMessage && this.authService.userIsResident) {
            this.residentService.updateWelcomeMessage();
            this.residentService.getBuildingsInfo();
        }
        if (this.showEditPanel) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.propertyService.isWelcomeModalShow = false
            );
        } else
            this.propertyService.isWelcomeModalShow = false;
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    onSubmit(form: NgForm) {
        if(this.welcomeMessage == '' || (this.welcomeMessage.replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
            toastr.warning('Welcome message should not be blank.');
            return;
        }

        const data = {
            welcomeMessage : this.welcomeMessage
        };
        this.disabledSubmit = true;
        this.propertyService.updateBuildingInfo(data).subscribe(
             (error) => { this.propertyService.isWelcomeModalShow = false; },
             () => { this.disabledSubmit = false; }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.propertyService.getBuildingInfo();
        this.form.reset();
        this.hideModal();
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.welcomeMessage = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['help', ['help']],
                ['table', ['table']],
                ['insert', ['link', 'hr']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
        <div class="input-group-btn email-placeholders-btn">
            <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle" 
                    type="button" aria-expanded="false">PL <span class="caret"></span></button>
            <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
        </div>
    `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.welcomeMessage).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.welcomeMessage).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeEditPanel() {
        this.showEditPanel = false;
        this.welcomeMessage = this.propertyService.currentWelcomeMessage ? this.propertyService.currentWelcomeMessage.slice() : '';
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/welcome-message-modal/welcome-message-modal.component.ts